import styled from 'styled-components';

export const StyledSelectWrapper = styled.div`
    position: relative;
    padding-bottom: 18px;
    width: 330px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 32px;
`;
